<template>
  <HeadlessTransitionRoot
    appear
    :show="show"
    as="template"
  >
    <HeadlessDialog
      as="div"
      class="relative z-50"
      @close="emit('close')"
    >
      <HeadlessTransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25">
          <MouseFollower :hide-when-over-el="dialogPanelEl" />
        </div>
      </HeadlessTransitionChild>

      <div class="fixed bottom-0 left-0 top-0 w-screen overflow-y-auto overflow-x-hidden">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <HeadlessTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <HeadlessDialogPanel class="w-full max-w-2xl rounded-2xl shadow-xl transition-all">
              <div
                ref="dialogPanelEl"
                class="w-full transform overflow-hidden rounded-2xl bg-white py-8"
              >
                <h1 class="mx-8 mb-4 text-start text-xl font-medium">Заказ № {{ order.id }}</h1>

                  <div class="flex flex-col items-center mx-4 rounded-xl bg-white p-5 shadow-main lg:mx-8 mt-1">
                      <div class="flex gap-6 items-center">
                          <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : order.status == 'received'}">
                              <img src="~/assets/icon/icon-checkmark.svg" alt="">
                          </div>

                          <div class="flex gap-1">
                              <div class="w-1 h-1 bg-gray2-100 rounded-full"></div>
                              <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                              <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                          </div>

                          <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : order.status == 'cooking'}">
                              <img src="~/assets/icon/icon-hat.svg" alt="">
                          </div>

                          <div class="flex gap-1">
                              <div class="w-1 h-1 bg-gray2-100 rounded-full"></div>
                              <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                              <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                          </div>

                          <template v-if="order.delivery_by_courier">
                              <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : order.status == 'on_way'}">
                                  <img src="~/assets/icon/icon-car.svg" alt="">
                              </div>

                              <div class="flex gap-1">
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full"></div>
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                              </div>
                          </template>

                          <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : order.status == 'completed' || (!order.delivery_by_courier && order.status == 'on_way')}">
                              <img src="~/assets/icon/icon-flag.svg" alt="">
                          </div>
                      </div>

                      <div class="mt-5 text-center">{{ order.status_text }}</div>
                  </div>

                <div
                  class="grid overflow-hidden transition-all"
                >
                  <div class="min-h-0">
                    <ul class="p-8 text-start text-sm">
                        <template
                          v-for="(p, index) in order?.items"
                          :key="index"
                        >
                          <li class="flex items-center gap-2">
                            <p class="shrink-0 grow-[4] basis-0">{{ p.name }}{{ p.price == 0 ? " (подарок)" : "" }}</p>
                            <p class="shrink-0 grow-[2] basis-0 text-end">{{ p.quantity }} шт</p>
                            <p class="shrink-0 grow-[2] basis-0 text-end">{{ p.price }} &#8381;</p>
                          </li>
                          <div class="my-2 h-px bg-gray last:hidden"></div>
                        </template>
                    </ul>
                  </div>
                </div>

                <div class="mx-4 mb-4 h-px bg-gray"></div>
                <p class="mx-8 text-start text-sm font-medium" v-if="order.delivery_price > 0">Доставка: {{ order.delivery_price }} &#8381;</p>
                <p class="mx-8 text-start text-sm font-medium" v-if="order.total_discount > 0">Скидка: {{ order.total_discount }} &#8381;</p>
                <p class="mx-8 text-start text-sm font-medium" v-if="order.paid_with_bonuses > 0">Оплачено баллами: {{ order.paid_with_bonuses }} &#8381;</p>
                <p class="mx-8 text-start text-xl font-medium">Итого: {{ order.total_sum }} &#8381;</p>
              </div>
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import { ref, toRefs } from 'vue'
import type { Order } from '~/interfaces/users'
import { getOrderStatusString } from '~/utils'

const props = defineProps<{
  show?: boolean
  order: Order
}>()
const { show, order } = toRefs(props)
const emit = defineEmits(['close'])

/*
const { data, isSuccess } = useOrder({
  enabled: show,
  orderID: order.value.id,
  select: (v) => v,
})*/

const dialogPanelEl = ref<HTMLElement>()
</script>
